export const CompanyEndpoints = {
  create: '/preferences/company/create',
  list: '/preferences/company/list',
  details: (id: string) => `/preferences/company/${id}`,
  edit: (id: string) => `/preferences/company/edit/${id}`,
  toggleStatus: (id: string) => `/preferences/company/status/${id}`,
};
